import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { destFor, takeIntent } from "@/lib/authRedirect";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const fromHash = new URLSearchParams((location.hash || "").replace("#", "")).get("session_id");
    const fromQuery = new URLSearchParams(location.search || "").get("session_id");
    const sessionId = fromHash || fromQuery;
    const { role, dest } = takeIntent();

    const fail = (message) => navigate("/login", { replace: true, state: { authError: message } });

    const run = async () => {
      if (!sessionId) {
        fail("Google sign-in was cancelled or did not complete. Please try again.");
        return;
      }
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId, role });
        setUser(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(destFor(data.user, dest), { replace: true, state: { user: data.user } });
      } catch (e) {
        fail(formatApiError(e.response?.data?.detail) || "We couldn't complete your Google sign-in.");
      }
    };
    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-3" data-testid="auth-callback">
      <Loader2 className="h-8 w-8 animate-spin text-accent" />
      <p className="text-muted-foreground">Signing you in…</p>
    </div>
  );
}
